import { Directive, HostListener, ElementRef, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CommonServices } from '../Common/CommonServices';

@Directive({
  selector: '[numbersonlyChecker]',
  standalone: false
})
export class NumbersonlyDirective {

  private regex: RegExp = /^[0-9]+$/;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private commonServices: CommonServices,
    @Optional() private ngControl: NgControl
  ) { }

  // ✅ Mobile-safe input handling
  @HostListener('input', ['$event'])
  onInput(event: Event) {

    const inputElement = this.el.nativeElement;
    const currentValue = inputElement.value;

    if (currentValue && !this.regex.test(currentValue)) {

      // Remove non-numeric characters
      const sanitizedValue = currentValue.replace(/[^0-9]/g, '');

      // Update DOM
      inputElement.value = sanitizedValue;

      // 🔥 Sync with Reactive Form (IMPORTANT FIX)
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(sanitizedValue, { emitEvent: false });
      }

      this.commonServices.showMessage('error', 'Numbers only', 2);
    }
  }

  // ✅ Paste handling (same logic preserved)
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {

    const clipboardData = event.clipboardData?.getData('text') || '';

    if (!this.regex.test(clipboardData)) {

      event.preventDefault();

      this.commonServices.showMessage(
        'error',
        'Pasted content must be numbers only',
        2
      );
    }
  }
}